// The ONE tracker session id (ex_sid) — shared by Tracker.tsx and every lead/log sender (Founder 2026-09-27: a lead must always
// carry its visit). 04/10/26: the implementation lives in lib/trackClient.mjs — the ONE client tracking door the 3D journey
// (window.ExTrack) runs too. Never re-implement it here.
// @ts-ignore — plain browser JS module (also inlined into x3d-assets/journey2.html)
import { getSessionId as sidImpl } from '@/lib/trackClient.mjs';
export function getSessionId(): string { return sidImpl() as string; }
